var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2v6h6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13l-1.5 1.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13l1.5 1.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15h10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15l1-4h8l1 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRto);
export default __webpack_public_path__ + "static/media/rto.58bb1b0c067400ea5f8ba4146ce37446.svg";
export { ForwardRef as ReactComponent };